import { downloadSafetyCheckSheetAttachment } from '../../../api/safety';
import { parseSafetyCheckItems, SafetyCheckSheet } from '../../../types/safety';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../quality/CleanActivityPanel.css';
import '../../quality/SmallGroupPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: SafetyCheckSheet;
}

function SafetyCheckPreviewView({ detail }: Props) {
  const items = parseSafetyCheckItems(detail.itemsJson);

  return (
    <div className="sg-panel">
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>안전관리 점검시트</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            시트번호
            <input readOnly value={detail.sheetNo || '-'} />
          </label>
          <label>
            점검일
            <input type="date" readOnly value={detail.checkDate || ''} />
          </label>
          <label className="is-span-2">
            제목 *
            <input readOnly value={detail.title || ''} />
          </label>
          <label>
            점검 구역
            <input readOnly value={detail.areaName || ''} />
          </label>
          <label>
            점검자
            <input readOnly value={detail.checkerName || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={3} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="ca-section-head">
          <h3>점검 항목</h3>
        </div>
        <div className="ca-items">
          {items.map((item, idx) => (
            <div className="ca-item-card" key={item.id}>
              <div className="ca-item-card__head">
                <strong>항목 {idx + 1}</strong>
              </div>
              <div className="ca-item-card__grid">
                <label className="is-wide">
                  점검항목
                  <textarea rows={2} readOnly value={item.checkItem || ''} />
                </label>
                <label>
                  방법
                  <textarea rows={2} readOnly value={item.method || ''} />
                </label>
                <label>
                  결과
                  <select disabled value={item.result || ''}>
                    <option value="">-</option>
                    <option value="OK">양호</option>
                    <option value="NG">미흡</option>
                    <option value="NA">해당없음</option>
                  </select>
                </label>
                <label className="is-full">
                  발견사항
                  <textarea rows={2} readOnly value={item.finding || ''} />
                </label>
                <label className="is-full">
                  비고
                  <textarea rows={2} readOnly value={item.remark || ''} />
                </label>
              </div>
            </div>
          ))}
          {items.length === 0 ? (
            <p className="quality-form__hint">등록된 점검 항목이 없습니다.</p>
          ) : null}
        </div>
      </section>

      <section className="quality-form__section">
        <h3 style={{ margin: '0 0 8px' }}>첨부파일</h3>
        <p className="quality-form__hint">관련 파일을 첨부할 수 있습니다.</p>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadSafetyCheckSheetAttachment(
              detail.sheetId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>
    </div>
    </div>
  );
}

export default SafetyCheckPreviewView;
